module.exports = __webpack_public_path__ + "static/media/Mask Group 175.dc938925.svg";